import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import styles from './Navbar.module.css'

function Navbar() {
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const navigate = useNavigate()

    // Usar el contexto de autenticación
    const { isAuthenticated, userName, userEmpresa, signOut, isLoading, isSuperAdmin } = useAuth()

    const handleSignOut = async () => {
        await signOut()
        navigate('/')
    }

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen)
    }

    return (
        <nav className={styles.navbar}>
            <div className={styles.container}>
                <Link to="/" className={styles.logo}>
                    <img src="/logo.png" alt="Ingconia Logo" className={styles.logoImage} />
                </Link>

                {/* Desktop Menu */}
                <div className={styles.navLinks}>
                    <Link to="/" className={styles.navLink}>Inicio</Link>
                    <Link to="/servicios" className={styles.navLink}>Servicios</Link>
                    <Link to="/contacto" className={styles.navLink}>Contáctenos</Link>

                    {!isLoading && (
                        <>
                            {isAuthenticated ? (
                                <>
                                    <Link to="/dashboard" className={styles.navLink}>Dashboard</Link>
                                    {isSuperAdmin && (
                                        <Link to="/admin" className={styles.navLink} style={{ color: '#818cf8' }}>
                                            ⚙️ Admin
                                        </Link>
                                    )}
                                    <div className={styles.userMenu}>
                                        <div className={styles.userInfo}>
                                            <span className={styles.userName}>{userName}</span>
                                            <span className={styles.userEmpresa}>{userEmpresa}</span>
                                        </div>
                                        <button
                                            onClick={handleSignOut}
                                            className={styles.logoutBtn}
                                        >
                                            Cerrar Sesión
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <Link to="/login" className={styles.loginBtn}>
                                    Iniciar Sesión
                                </Link>
                            )}
                        </>
                    )}
                </div>

                {/* Mobile Menu Button */}
                <button
                    className={styles.menuToggle}
                    onClick={toggleMenu}
                    aria-label="Toggle menu"
                >
                    <span className={styles.hamburger}></span>
                    <span className={styles.hamburger}></span>
                    <span className={styles.hamburger}></span>
                </button>
            </div>

            {/* Mobile Menu */}
            {isMenuOpen && (
                <div className={styles.mobileMenu}>
                    <Link to="/" className={styles.mobileLink} onClick={toggleMenu}>Inicio</Link>
                    <Link to="/servicios" className={styles.mobileLink} onClick={toggleMenu}>Servicios</Link>
                    <Link to="/contacto" className={styles.mobileLink} onClick={toggleMenu}>Contáctenos</Link>

                    {!isLoading && (
                        <>
                            {isAuthenticated ? (
                                <>
                                    <Link to="/dashboard" className={styles.mobileLink} onClick={toggleMenu}>Dashboard</Link>
                                    {isSuperAdmin && (
                                        <Link to="/admin" className={styles.mobileLink} onClick={toggleMenu} style={{ color: '#818cf8' }}>
                                            ⚙️ Panel Admin
                                        </Link>
                                    )}
                                    <div className={styles.mobileUserInfo}>
                                        <span className={styles.mobileUserName}>{userName}</span>
                                        <span className={styles.mobileUserEmpresa}>{userEmpresa}</span>
                                    </div>
                                    <button
                                        onClick={() => { handleSignOut(); toggleMenu(); }}
                                        className={styles.mobileLink}
                                    >
                                        Cerrar Sesión
                                    </button>
                                </>
                            ) : (
                                <Link to="/login" className={styles.mobileLink} onClick={toggleMenu}>
                                    Iniciar Sesión
                                </Link>
                            )}
                        </>
                    )}
                </div>
            )}
        </nav>
    )
}

export default Navbar
